export default {
    /**
     * Datos añadidos a data por el mixin:
     * - tinTypesOptions: array con tipos de tin
     *
     * @return {Object} Data del mixin
     */
    data() {
        return {
            tinTypesOptions: []
        };
    },
    methods: {
        /**
         * Load Tin types
         */
        loadTinTypesOptions() {
            const tinTypes = this.$t(`interveners.fatca.tin_type`);
            this.tinTypesOptions = Object.entries(tinTypes).map(item => {
                return {
                    key: item[0],
                    name: item[1]
                };
            });
        }
    },

    /**
     * Antes de montar el componente se cargan los tipos de tin en la variable
     * `this.tinTypesOptions`
     */
    beforeMount() {
        this.loadTinTypesOptions();
    }
};

